import _ from 'underscore';
import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import * as filterPreferences from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import { sessionStore } from '@bingads-webui/js-data-storage';
import { REVIEW_STATUS_TEXT } from '../constants';

function mapKeyValue(object, fn) {
  return _.chain(object)
    .pairs()
    .map(fn)
    .object()
    .value();
}

const schema = ({ i18n }) => ({
  name: 'BrandItem',
  type: 'object',
  properties: {
    BrandName: {
      type: 'string',
      title: i18n.getString(_TL_('Brands')),
      filterable: true,
      customColumn: true,
    },
    Uri: {
      type: 'string',
      title: i18n.getString(_TL_('Website')),
      filterable: true,
      customColumn: true,
    },
    EditorialStatus: {
      type: 'string',
      title: i18n.getString(_TL_('Status')),
      filterable: true,
      customColumn: true,
      chooseType: 'checkbox',
      enum: Object.keys(REVIEW_STATUS_TEXT),
      localized: mapKeyValue(REVIEW_STATUS_TEXT, ([key, value]) => [
        `Enum.EditorialStatus'${key}'`,
        i18n.getString(value),
      ]),
    },
  },
});

export function getFilterConfig({
  i18n,
  preferenceService,
}) {
  const filterConfig = getCommonFilterConfig({
    preferenceService,
    featureName: 'BrandListsDetails',
    entitySchema: schema({ i18n }),
    i18n,
    legacyGlobalI18n: i18n,
    sessionStore,
    preferenceStoreFactory: filterPreferences.getFilters,
    schemaI18nCampaign: {},
    dataContextManager: {},
    jsdata: {},
    updatePilot: false,
    enableCampaignWaterfall: false,
    editor: {},
  });

  return filterConfig;
}
